(function () {
  const SOURCE_SELECTOR = '#true-fit-widget-source';
  const TARGET_SELECTOR = '#true-fit-widget-drawer-target';
  const RETRY_DELAYS = [0, 300, 800, 1500, 3000, 5000];

  function hasContent(element) {
    return element.children.length > 0 || element.innerText.trim().length > 0;
  }

  function syncToDrawer() {
    const source = document.querySelector(SOURCE_SELECTOR);
    const target = document.querySelector(TARGET_SELECTOR);

    if (!source || !target || !hasContent(source)) return false;

    const html = source.innerHTML;
    target.innerHTML = html;
    return true;
  }

  function init() {
    const source = document.querySelector(SOURCE_SELECTOR);
    const target = document.querySelector(TARGET_SELECTOR);
    if (!source || !target) return;

    if (syncToDrawer()) return;

    let attempt = 0;
    function retry() {
      if (attempt >= RETRY_DELAYS.length) return;
      const delay = RETRY_DELAYS[attempt++];
      setTimeout(() => {
        if (!syncToDrawer()) retry();
      }, delay);
    }
    retry();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
